<template>
  <form
    class="input-wrapper"
    @submit.prevent
  >
    <img src="@/assets/ico/search-gray.svg">
    <input
      v-model="searched"
      :placeholder="currPlaceholder"
      required
      @focus="currPlaceholder = ''"
      @blur="currPlaceholder = placeholder"
      @input="$emit('input', searched)"
      @keydown.esc="$event.target.blur()"
    >
    <!-- required is used for focus/filled styling-->
    <img
      v-if="searched !== ''"
      :src="require('@/assets/_desktop/_shared/clear.svg')"
      class="clear"
      @click="clear"
    >
  </form>
</template>

<script>

export default {
  props: {
    placeholder: {
      default: '',
      type: String
    },
  },
  data() {
    return {
      searched: '',
      currPlaceholder: this.placeholder,
    }
  },
  methods: {
    clear() {
      this.searched = ''
      this.$emit('input', this.searched)
    },
  },
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  min-height: 40px;
  border: 1px solid $flax-bloom;

  &:hover,
  &:focus-within,
  &:valid {
    // white if hovered/focused/filled
    background-color: white;
  }
  &:focus-within {
    @include animate-border-focused;
    border: 1px solid $blue;
  }
  @include animate-border-default(2px, -1px);

  input {
    background-color: transparent;
    &::placeholder {
      color: #9093c0;
    }
  }
  img {
    margin-right: 10px;
    top: 0;
    bottom: 0;
    &.clear {
      width: 18px;
    }
  }
}
</style>
